import { ReactElement } from "react";
import { Button } from "@mui/material";
import logoLight from "./assets/logo-optimus-dark.png";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./configuration/authConfig";

const UnauthenticatedPage = (): ReactElement => {
  const { instance } = useMsal();

  const onRequestAccessToken = () => {
    instance.loginRedirect(loginRequest)
      .catch((e: Error) => console.error(e));
  };

  return (
    <div className="display-flex-column justify-content-center" style={{ height: "100dvh" }}>
      <div className="display-flex-column align-self-center" style={{ width: 200, height: 250 }}>
        <img src={logoLight} alt={"optimus-steel-logo"} style={{ maxHeight: "180px", margin: "1em", marginBottom: "2em" }}/>
        <Button onClick={onRequestAccessToken} color="primary" variant="outlined">Sign In</Button>
      </div>
    </div>
  );
};

export default UnauthenticatedPage;
